/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAiTelemetryIngestion extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAiTelemetryIngestion");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAiTelemetryIngestion.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAiTelemetryIngestion>): BackgroundJobPayloadForPeriodicAiTelemetryIngestion {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAiTelemetryIngestion(), model);
        BackgroundJobPayloadForPeriodicAiTelemetryIngestion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAiTelemetryIngestion>): BackgroundJobPayloadForPeriodicAiTelemetryIngestion {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAiTelemetryIngestion.newInstance(<BackgroundJobPayloadForPeriodicAiTelemetryIngestion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAiTelemetryIngestion) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAiTelemetryIngestion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAiTelemetryIngestion): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAiTelemetryIngestion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
